// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2GWfO","messages":"Chat_messages__F9wHN","dateDivider":"Chat_dateDivider__3Jg1e"};